import React from 'react';
import {connect} from 'react-redux';
import {fetchCasUrl} from "reducers/authenticationNew";

const mapStateToProps = (state) => ({
  loading: state.authentication.loading,
  isAuthenticated: state.authentication.isAuthenticated
});
const mapDispatchToProps = {
};

const PrivateRoute = connect(mapStateToProps, mapDispatchToProps)(class extends React.Component {

  componentDidMount() {
    this.redirectIfNotLogged(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.redirectIfNotLogged(nextProps);
  }

  redirectIfNotLogged(props) {
    const {loading, isAuthenticated} = props;
    let casUrl = "";
    fetchCasUrl().then(response=>{
       casUrl = response.data;
    });

    // console.log("0-0-------------", casUrl);
    // var time1 = new Date().getTime();
    // var time2 = time1 + 10000;
    // while(true){
    //   if (new Date().getTime() > time2){return;}
    // }

    if (loading === false && !isAuthenticated) {
      // window.location.href = casUrl + `/cas/login?service=${window.location.origin}`;
      this.props.history.push('/exception/403');
      // this.props.history.push('/');
    }
  }

  render() {
    const {loading, isAuthenticated} = this.props;
    if (loading || !isAuthenticated) {
      return (
        <div className="center loader">
          <div>Loading...</div>
        </div>
      );
    }

    return <>{this.props.children}</>;
  }
});

export default PrivateRoute;
